export default __webpack_public_path__ + "static/media/rider.50f8bd66.png";